import React from 'react';
import Swal from 'sweetalert2';
import { Link } from "react-router-dom";
import authAxios from "../../services/Token";
import { currencyFormat } from '../../js/Functions';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleDoubleLeft, faAngleDoubleRight, faAngleLeft, faAngleRight, faEdit, faFileWord, faFilter, faPlus, faSearch, faTrashAlt } from '@fortawesome/free-solid-svg-icons';
import MovementsWord from './MovementsWord';

class Listar extends React.Component {
    constructor(props) {
        super(props);
    }
    state = {
        load: '',
        movement_year: '',
        arrayResult: [],
        movementsWord: [],
        errors: []
    }
    changeValue = (e) => {
        const state = this.state;
        state[e.target.name] = e.target.value;
        this.setState({ state, errors: [] })
    }
    errorVerify(element) {
        return this.state.errors.indexOf(element) !== -1;
    }
    deleteRecords = (id) => {
        Swal.fire({
            title: 'Are you sure to Delete the Record?',
            showDenyButton: true,
            showCancelButton: false,
            confirmButtonText: 'Delete',
            denyButtonText: `Cancel`,
        }).then((result) => {
            if (result.isConfirmed) {
                authAxios.get("movements/delete/" + id)
                    .then((dataResult) => {
                        console.log(dataResult);
                        Swal.fire('Deleted!', dataResult.data.msj, 'success')
                        this.ListarArrayResult(1);
                    })
                    .catch(console.log);
            } else if (result.isDenied) {
                Swal.fire('Canceled', '', 'info')
            }
        })
    };
    ListarArrayResult(page, tab = null) {
        Swal.showLoading();
        let btype = document.getElementById('btype').value;
        let bname = document.getElementById('bname').value;
        if (bname == '') {
            bname = 0;
        }
        if (btype == '') {
            btype = 0;
        }
        authAxios.get("movements/index/" + btype + "/" + bname + "?page=" + page)
            .then((dataResult) => {
                console.log(dataResult);
                Swal.close();
                var status = dataResult.data.status;
                if (status) {
                    Swal.fire('Token has Expired!', 'Re-Login', 'info');
                    window.localStorage.clear();
                    window.location.href = '/';
                }
                this.setState({
                    arrayResult: dataResult.data.data,
                    page: dataResult.data.total,
                    last: dataResult.data.last_page,
                    current: dataResult.data.current_page
                });
            })
            .catch(console.log);
    }
    previewWord = (e) => {
        var movement_year = e.target.value;
        Swal.showLoading();
        authAxios.get('movements/generate_word/' + movement_year)
            .then((response) => {
                Swal.close()
                var status = response.data.status;
                if (!status) {
                    Swal.fire('Token ha Expirado!', 'Vuelva a Iniciar Sesión', 'info');
                    window.localStorage.clear();
                    window.location.href = '/';
                }
                this.setState({ movementsWord: response.data.movements })
                Swal.close();
            })
            .catch(error => {
                console.error("Error fetching data:", error);
            });
    }
    componentDidMount() {
        this.ListarArrayResult(1);
    }
    render() {
        const {
            load,
            arrayResult,
            movementsWord,
            page,
            last,
            current
        } = this.state;
        return (
            <div className="content">
                <div className="container-fluid">
                    <br/>
                    <div className="card">
                        <div className="card-header">
                            <Link className="btn btn-success btn-sm" to={"/AddMovements"}><FontAwesomeIcon icon={faPlus} />&nbsp;&nbsp;Add Movement</Link>&nbsp;&nbsp;
                            <button style={{ color: '#FFFFFF' }} type="button"
                                className="btn btn-info btn-sm" data-bs-toggle='modal'
                                data-bs-target="#DownloadMovementsModal"
                            >
                                <FontAwesomeIcon icon={faFileWord} />&nbsp;&nbsp;Download Movements
                            </button>
                        </div>
                        <div className="card-body">
                            <h4>Movements</h4>
                            <hr />
                            <div className="row">
                                <div className="col-xl-2">
                                    <select name="btype" id="btype"
                                        className={"form-select form-select-sm"}>
                                        <option value="">CHOOSE...</option>
                                        <option value="1">BY MONTH</option>
                                        <option value="2">BY YEAR</option>
                                    </select>
                                </div>
                                <div className="col-xl-4">
                                    <input style={{ textTransform: 'uppercase' }} type="text" id="bname" name="bname" placeholder="Search for Movement" className="form-control form-control-sm" />
                                </div>
                                <div className="col-xl-3">
                                    <button id="bt" name="bt" className="btn btn-secondary btn-sm" onClick={() => this.ListarArrayResult(1)}><FontAwesomeIcon icon={faFilter} />&nbsp;&nbsp;Filter</button>
                                </div>
                            </div>
                            <br></br>
                            <div className="row">
                                <div className="col-xl-12">
                                    <table className="table table-hover table-condensed table-sm">
                                        <thead className="thead-inverse">
                                            <tr>
                                                <th className="align-middle">YEAR</th>
                                                <th className="align-middle">MONTH</th>
                                                <th className="align-middle">DATE</th>
                                                <th className="align-middle">INITIAL BALANCE</th>
                                                <th className="align-middle">MOVEMENTS</th>
                                                <th className="align-middle">FINAL BALANCE</th>
                                                <th className="align-middle">ACTION</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {load}
                                            {
                                                arrayResult.map((itemArrayResult) => (
                                                    <tr key={itemArrayResult.ID_MOVEMENT}>
                                                        <td>{itemArrayResult.YEAR}</td>
                                                        <td>{itemArrayResult.MONTH}</td>
                                                        <td>{itemArrayResult.DATE}</td>
                                                        <td><span style={{ fontSize: 11, textTransform: 'uppercase' }} className="badge bg-success"><b>$ </b>{currencyFormat(itemArrayResult.BALANCE)}</span></td>
                                                        <td><span style={{ fontSize: 11, textTransform: 'uppercase' }} className={itemArrayResult.TOTAL_MOVEMENTS >= 0 ? "badge bg-success" : "badge bg-danger"}><b>$ </b>{currencyFormat(itemArrayResult.TOTAL_MOVEMENTS)}</span></td>
                                                        <td><span style={{ fontSize: 11, textTransform: 'uppercase' }} className={itemArrayResult.FINAL_BALANCE >= 0 ? "badge bg-success" : "badge bg-danger"}><b>$ </b>{currencyFormat(itemArrayResult.FINAL_BALANCE)}</span></td>
                                                        <td>
                                                            <div className="btn-group" role="group" aria-label="">
                                                                <Link
                                                                    className="btn btn-primary btn-sm"
                                                                    to={"/UpMovements/" + itemArrayResult.ID_MOVEMENT}
                                                                >
                                                                    <FontAwesomeIcon icon={faEdit} />
                                                                </Link>&nbsp;&nbsp;
                                                                <button
                                                                    type="button"
                                                                    className="btn btn-danger btn-sm"
                                                                    onClick={() =>
                                                                        this.deleteRecords(itemArrayResult.ID_MOVEMENT)
                                                                    }
                                                                >
                                                                    <FontAwesomeIcon icon={faTrashAlt} />
                                                                </button>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                ))
                                            }
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <nav aria-label="Page navigation example">
                                <ul className="pagination">
                                    <li className="page-item"><a className="page-link" href="#" onClick={() => this.ListarArrayResult(1)}><FontAwesomeIcon icon={faAngleDoubleLeft} /></a></li>
                                    <li className="page-item"><a className="page-link" href="#" onClick={() => this.ListarArrayResult(current - 1)}><FontAwesomeIcon icon={faAngleLeft} /></a></li>
                                    {(() => {
                                        let p = [];
                                        p.push(<li className="page-item" key={current}><a className="page-link" href="#" onClick={() => this.ListarArrayResult(current)}>{current}</a></li>);
                                        return p;
                                    })()}
                                    <li className="page-item"><a className="page-link" href="#" onClick={() => this.ListarArrayResult(current + 1)}><FontAwesomeIcon icon={faAngleRight} /></a></li>
                                    <li className="page-item"><a className="page-link" href="#" onClick={() => this.ListarArrayResult(last)}><FontAwesomeIcon icon={faAngleDoubleRight} /></a></li>
                                </ul>
                            </nav>
                        </div>
                        <div className="card-footer text-muted">
                            <b>Page</b> <span className="badge bg-primary">{current}</span> <b>of</b> <span className="badge bg-primary">{last}</span> | <b>Records</b> <span className="badge bg-success">{page}</span>
                        </div>
                    </div>
                </div>
                <div className="modal fade" id="DownloadMovementsModal" data-bs-backdrop="static" data-bs-keyboard="false" aria-labelledby="DownloadMovementsLabel" aria-hidden="true">
                    <div className="modal-dialog modal-md" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h4 className="modal-title w-100 text-center" id="DownloadMovementsLabel">Download Movements</h4>
                                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                            </div>
                            <div className="modal-body">
                                <div className='row g-3'>
                                    <div className='col-md-11 text-center'>
                                        <label htmlFor="movement_year">Movement Year</label>
                                        <select name="movement_year"
                                            id="movement_year"
                                            className="form-select form-select-sm"
                                            onChange={(e) => {
                                                this.changeValue(e);
                                                this.previewWord(e);
                                            }}>
                                            <option value="">CHOOSE...</option>
                                            <option value="2024">2024</option>
                                            <option value="2025">2025</option>
                                        </select>
                                    </div>
                                    <div className='col-md-1'>
                                        <label htmlFor="movement_year">&nbsp;</label>
                                        <MovementsWord data={movementsWord} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Listar;